import Backbone from 'backbone';
import React from 'react';
import ReactDOM from 'react-dom';

import FileStates from 'FileStates';
import * as navigation from 'Navigation';
import NoteLinkedEmbeddingPreview from 'notebook/embeddings/NoteLinkedEmbeddingPreview';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';

interface NoteLinkedEmbeddingTabStateDefaults extends navigation.TabStateDefaults {
  contentId: string | null;
  embedding: React.ReactNode | null;
}

class NoteLinkedEmbeddingTabState extends navigation.TabState {
  defaults(): NoteLinkedEmbeddingTabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Preview Embedding',
      closeable: true,
      contentId: null,
      embedding: null,
      preferenceKey: 'embedding',
    };
  }

  contentId(): string {
    return this.get('contentId');
  }
}

class NoteLinkedEmbeddingTabView extends Backbone.View<NoteLinkedEmbeddingTabState> {
  static initClass(): void {
    this.prototype.className = 'buffer-tab buffer-tab--no-padding';
  }

  initialize(): void {
    this.listenTo(this.model, 'change', () => this.render());
  }

  render(): Backbone.View<NoteLinkedEmbeddingTabState> {
    const handleClose = (): void => {
      this.model.close();
    };
    renderToDOM(
      <NoteLinkedEmbeddingPreview onClose={handleClose}>
        {this.model.get('embedding')}
      </NoteLinkedEmbeddingPreview>,
      this.el
    );
    return this;
  }

  remove(): Backbone.View<NoteLinkedEmbeddingTabState> {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}
NoteLinkedEmbeddingTabView.initClass();

function open(fileId: string, contentId: string, title: string, embedding: React.ReactNode): void {
  const fileState = FileStates.get().get(fileId);

  const existingTab = fileState.findTab(
    NoteLinkedEmbeddingTabState,
    (tab: NoteLinkedEmbeddingTabState) => tab.contentId() === contentId
  );

  if (existingTab != null) {
    existingTab.set({active: true});
    return;
  }

  fileState.buffers().addTab(new NoteLinkedEmbeddingTabState({contentId, embedding, title}));
}

const NoteLinkedEmbeddingTab = {
  tabState: NoteLinkedEmbeddingTabState,
  tabView: NoteLinkedEmbeddingTabView,
  open,
};

export default NoteLinkedEmbeddingTab;
